<template>
    <div class="modal" id="loading-modal" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $lang('Proszę czekać...') }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <pulse-loader :color="'#000'"></pulse-loader>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {EventBus} from "../mixins/event-bus";
import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
export default {
    name: "loading-widget",
    components: {
        'PulseLoader': PulseLoader
    },
    mounted() {
        EventBus.$on('showLoader', (result) => {
            $('#loading-modal').modal('show');
        });
        EventBus.$on('hideLoader', (result) => {
            $('#loading-modal').modal('hide');
        });
    }
}
</script>
